import React, { useEffect, useRef, useState } from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

import ResultsBox from './components/ResultsBox';
import SearchField from './components/SearchField';

function useOutsideAlerter(ref, callback) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback && callback();
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
}

const Container = ({ searchFieldRef }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const wrapperRef = useRef(null);
    const resultBoxRef = useRef(null);

    const handleClick = () => setAnchorEl(wrapperRef.current);

    const clearSearch = () => {
        setSearchQuery('');
        setAnchorEl(null);
    };

    useOutsideAlerter(wrapperRef, () => clearSearch());

    return (
        <Box
            id="search-wrapper"
            ref={wrapperRef}
            sx={{
                alignItems: 'center',
                position: 'relative',
            }}
        >
            <SearchField
                clearSearch={clearSearch}
                handleClick={handleClick}
                open={open}
                resultBoxRef={resultBoxRef}
                searchFieldRef={searchFieldRef}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
            />

            <ResultsBox
                anchorEl={anchorEl}
                clearSearch={clearSearch}
                open={open}
                resultBoxRef={resultBoxRef}
                searchFieldRef={searchFieldRef}
                searchQuery={searchQuery}
                setAnchorEl={setAnchorEl}
            />
        </Box>
    );
};

Container.propTypes = {
    searchFieldRef: PropTypes.object,
};

export default Container;
